import { Draft } from '@/types';

export const getConfigurations = (draft: Pick<Draft, 'configurations'>) =>
  Object.values(draft.configurations);
